import React, { useRef } from 'react';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import FileUploadApp from '../../Functionality/FileUploadApp';
import ButtonAction from '../../../buttons/ButtonAction';
import { UpdateIconsOptions, UseCameraIcon } from '../../../buttons/IconButtons';
import { formatFileSize } from '../../../../Apis/functions';
import FullPageLoader from '../../../../utils/FullPageLoader';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description File upload component
 * @param String id: File input identifier (required).
 * @param model accept: Model of document types accepted by the component - default for image (required).
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param useState setFileSelected: Variable for storing the selected file (required).
 * @param String titleInput: File component title (optional).
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param event handleStartupWebcam: Event to start the camera.
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param className classHeight: To define the size of the file upload component
 * @param boolean emptyFields: default value is false
 * @param boolean isMultipleFile: Indicates whether multiple files will be uploaded.
 * @param file fileSelected: Selected file variable (required).
 * @param Base64 preview:  Base64 image for a default value (optional).
 *
 */
const CustomFileUpload = ({
    id = "fu_cfp_file",
    accept = FILE_TYPE.IMAGE,
    photoPickerFile,
    setPhotoPickerFile,
    titleInput = 'drag_your_file_or',
    required = false,
    disabled = false,
    showBtnCamera = false,
    handleStartupWebcam = null,
    validateFace = false,
    classHeight = '',
    emptyFields = false,
    isMultipleFile = false
}) => {

    const fileInputRef = useRef(null);

    const { t, onFileChange, handleDragOver, handleDrop, isLoadingLibrary } = FileUploadApp({ fileInputRef, photoPickerFile, setPhotoPickerFile, accept, validateFace, isMultipleFile });

    return (
        <>
        {isLoadingLibrary && <FullPageLoader/>}
        <label
            htmlFor={id}
            className={(disabled ? 'disabled' : '') + ' bg-dotted-border-box-photo-picker ' + classHeight}
            onDragOver={(e) => handleDragOver(e)}
            onDrop={(e) => handleDrop(e)}
        >
            <input id={id} type='file'
                ref={fileInputRef} className={"file-input"} accept={accept.accept}
                onChange={(e) => {
                    onFileChange(e);
                }}
                disabled={disabled}
                multiple={isMultipleFile}
            />
            <div className='d-flex flex-column justify-content-between'>
                <span className='text-center ibl-font-w-400 fs-13px font-color-secondary-500'>
                    {(t(titleInput).toUpperCase() + " " + t("click_to_upload").toUpperCase())}
                    {required && <span className={`${emptyFields ? 'font-color-error-600' : ''}`}> *</span>}
                </span>
                <span className='text-center ibl-font-w-700 fs-14px font-color-secondary-500'>  {`${t('max_size').toUpperCase()} ${formatFileSize(accept.size)}`} </span>
                {emptyFields && <span className={`text-center ibl-font-w-400 fs-14px font-color-error-600`}>{t('requiredField')}</span>}

            </div>
            <div className={`row mt-3`}>
                {showBtnCamera &&
                    <div className={"col-sm-12 col-md-6 px-1 py-1"}>
                        <ButtonAction
                            id='btn_ppu_use_camera'
                            name='use_camera'
                            className='btn-outlined-secondary-600-25 w-100'
                            Icon={UseCameraIcon}
                            splitName={false}
                            disabled={disabled}
                            onClick={() => {
                                if (handleStartupWebcam)
                                    handleStartupWebcam();
                            }}
                        />
                    </div>
                }
                <div className={`${showBtnCamera ? 'col-sm-12 col-md-6' : 'col-12'} px-1 py-1`}>
                    <ButtonAction
                        id='btn_ppu_upload_photo'
                        name='upload_file'
                        className={`btn-icon-upload-file w-100 `}
                        Icon={UpdateIconsOptions}
                        splitName={false}
                        disabled={disabled}
                        onClick={() => {
                            if (fileInputRef.current) {
                                fileInputRef.current.click();
                            }
                        }}
                    />
                </div>
            </div>

        </label>
        </>
    )
}

export default CustomFileUpload
